export const ELEMENT_RESIZING_START = 'ELEMENT_RESIZING_START';
export const ELEMENT_RESIZING_END = 'ELEMENT_RESIZING_END';

export const ELEMENT_RESIZE_INTERPOLATION_FACTOR = 0.3;
